import { Loading, QSpinnerDots } from 'quasar'

Loading.setDefaults({
  spinner: QSpinnerDots,
  spinnerColor: 'white',
  spinnerSize: 80,
  backgroundColor: 'input-color'
})
